import React from 'react';
import PropTypes from "prop-types";
import {connect} from 'react-redux';
import webservice from '../common/Webservice';
import {MEDIA_SIZES, footerNotice, contentLength, MAX_CHARACTERS} from "../misc/Shared";
import Media from "react-media";

const propTypes = {
    currentCobiId: PropTypes.number,

    currentTab: PropTypes.string,

    currentYear: PropTypes.number,

	draft: PropTypes.bool,
};

const defaultProps = {};

const mapStateToProps = state => ({
	currentCobiId: state.app.currentCobiId,
	currentTab: state.app.currentTab,
	currentYear: state.app.currentYear,
	draft: state.app.draft
});

class Background extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            content: undefined,
			readMore: false,
            statutes: []
        };

		this.setContent = this.setContent.bind(this);
		this.getContent = this.getContent.bind(this);

		this.getContent();
    }

	componentDidUpdate(prevProps) {
		if ((prevProps.currentCobiId !== this.props.currentCobiId) || (this.props.currentYear !== prevProps.currentYear)) {
			this.getContent();
		}
	}

	componentWillUnmount() {
		this.isCancelled = true;
	}

	getContent() {
		this.props.draft ?
			webservice.admin.tab.draft(this.props.currentCobiId, this.props.currentYear, this.props.currentTab).then(this.setContent)
			: webservice.public.tab.content(this.props.currentCobiId, this.props.currentYear, this.props.currentTab).then(this.setContent);
	}

	setContent(data) {
		!this.isCancelled && this.setState({content: data.text.tabHtml, statutes: data.statutes});
	}

    renderStatutes() {
        return (
            <div className="gray-box atid_statutes">
                <h2>Statutes</h2>
                {this.state.statutes.map(statute => {
                    return statute.isActive && (
                        <div key={statute.statuteId}>
                            <strong>
                                <a href={`https://le.utah.gov/UtahCode/LibLookup.jsp?maj=${statute.majorType}&min=${statute.minorType}&num=${statute.statuteNumber}`}
                                   target="_blank">{statute.title}</a>
                            </strong>
                            <p>{statute.summary}</p>
                        </div>
                    );
                })}
            </div>
        );
    }

    readMore(event, show) {
        this.setState({readMore: show});

        !show && window.scroll({top: event.target.offsetTop, left: 0});
    }

	renderContent(mobile) {
		let tabContent;
		let readMoreLink = undefined;
		if (mobile) {
			tabContent = (<div className={contentLength(this.state.content, MAX_CHARACTERS) ? this.state.readMore ? "mb-spacing" : "read-more" : "mb-spacing"}>
				<div dangerouslySetInnerHTML={{__html: this.state.content}}/>
			</div>);
			readMoreLink = contentLength(this.state.content, MAX_CHARACTERS) && (!this.state.readMore ?
					<a onClick={(e) => this.readMore(e, true)}
					   className="mb-spacing bold-text inline-block atid_read-more-link">
						READ MORE <span className="ml-spacing-small">&raquo;</span>
					</a>
					:
					<a onClick={(e) => this.readMore(e, false)}
					   className="mb-spacing bold-text inline-block atid_read-more-link">
						READ LESS <span className="ml-spacing-small">&raquo;</span>
					</a>
			);
		} else {
			tabContent = (<div dangerouslySetInnerHTML={{__html: this.state.content}}/>);
		}

		return (
			<div>
				<section className="description-area fr-view clearfix">
					{this.state.statutes.length > 0 && this.renderStatutes()}
					<div>
						{tabContent}
						{readMoreLink}
					</div>
				</section>
				{footerNotice()}
			</div>
		);
	}

    render() {
        return (
			<React.Fragment>
				{this.state.content && <div className="content" >
						<Media query={MEDIA_SIZES.TABLET_NARROW_MAX_WIDTH}>
							{matches =>
								this.renderContent(matches)
							}
						</Media>
				</div>}
			</React.Fragment>
		);
    }
}

Background.propTypes = propTypes;
Background.defaultProps = defaultProps;

export default connect(mapStateToProps)(Background);